// extracted by mini-css-extract-plugin
module.exports = {"container":"_eae1e7c0","icon":"_c61b279d"};